import React from 'react';

/**
 * The account glyph used by both the desktop guest menu and the mobile topbar.
 *
 * Shared rather than duplicated so the two headers cannot drift apart.
 *
 * `fill="none"` on the <svg> is NOT sufficient on its own: a presentation attribute loses to the
 * app-wide `svg { fill: currentColor }` rule in marketplaceDefaults.css, which would paint the head
 * as a solid disc. Every caller must also set `fill: none` in CSS on the wrapping element AND on the
 * svg itself — see `.menuIcon svg` in TopbarDesktop.module.css and `.profileIcon svg` in
 * Topbar.module.css.
 */
const ProfileIcon = props => {
  const { className, size = 18 } = props;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="9" cy="6" r="3.1" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M2.9 15.6c.6-2.9 3.1-4.9 6.1-4.9s5.5 2 6.1 4.9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ProfileIcon;
